import { render } from "./CrediCoreApp.vue?vue&type=template&id=f3594f8a&scoped=true"
import script from "./CrediCoreApp.vue?vue&type=script&lang=js"
export * from "./CrediCoreApp.vue?vue&type=script&lang=js"

import "./CrediCoreApp.vue?vue&type=style&index=0&id=f3594f8a&scoped=true&lang=css"

import exportComponent from "/var/www/html/AxumWebPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3594f8a"]])

export default __exports__